import { useEffect, useMemo, useRef } from "react";
import type { NextRouter } from "next/router";
import { ToasterService } from "@Front/Components/DesignSystem/Toaster";
import { getLoginErrorMessage } from "@Front/Components/Layouts/Login/constants/loginErrorCodes";

export function useLoginErrorParamToaster(router: NextRouter, loginErrorTitle: string): string | null {
	const errorParam = router.query["error"];
	const loginErrorMessage = useMemo(() => getLoginErrorMessage(errorParam), [errorParam]);
	const lastToasterErrorRef = useRef<string | null>(null);

	useEffect(() => {
		if (!loginErrorMessage) {
			lastToasterErrorRef.current = null;
			return;
		}
		if (lastToasterErrorRef.current === loginErrorMessage) {
			return;
		}
		lastToasterErrorRef.current = loginErrorMessage;
		ToasterService.getInstance().error({
			title: loginErrorTitle,
			description: loginErrorMessage,
		});
	}, [loginErrorMessage, loginErrorTitle]);

	return loginErrorMessage;
}
